import { render } from "./PageDashboard.vue?vue&type=template&id=2ef30e00"
import script from "./PageDashboard.vue?vue&type=script&lang=js"
export * from "./PageDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__